import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickDispatchTable from '@/components/brick_dispatch_table.vue'
import SummaryDispatch from '@/components/summary_dispatch.vue'
import Vue from 'vue'

Vue.component('SummaryDispatch', SummaryDispatch)

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-file', 'text-purple']
infos.front_classes = ['fas', 'fa-arrow-alt-down', 'text-white']
infos.name = 'dispatch'
infos.associated_class_name = 'AutomlDispatchTable'
infos.editing_component_name = 'BrickDispatchTable'
infos.editing_component = BrickDispatchTable
infos.summary_component_name = 'SummaryDispatch'
infos.summary_component = SummaryDispatch
infos.descriptions = {
	en: {
		short_tooltip_description: 'Dispatch',
		full_tooltip_description:
			'Defines similar data sources for which training and evaluation datasets are regrouped',
		navbar_name: 'Dispatch',
	},
	fr: {
		short_tooltip_description: 'Dispatch',
		full_tooltip_description:
			"Définition des sources similaires pour lesquelles l'entrainement et l'évaluation sont regroupés",
		navbar_name: 'Dispatch',
	},
}
// infos.short_tooltip_description = 'dispatch_short_tooltip'
// infos.full_tooltip_description = 'dispatch_full_tooltip'
// infos.navbar_name = 'dispatch_navbar'
infos.background_color = 'purple'

brick_registerer(infos)
